import { css } from "@emotion/react";
import { useState } from "react";
import Modal from "react-modal";
import { FaQuestionCircle } from "react-icons/fa";

const modalStyles = {
    content: {
        top: "10%",
        left: "10%",
        right: "10%",
        bottom: "auto"
    }
};

export default function AboutThisReport({ title, component: Component }) {
    const [isOpen, setIsOpen] = useState(false),
        openModal = () =>setIsOpen(true),
        closeModal = () => setIsOpen(false);

    return <>
        <div
            onClick={openModal}
            css={css`
                        display: inline;
                        font-size: 0.65rem;
                        line-height: 1rem;
                        color: var(--podtrac-blue-darker);
                        cursor: pointer;
                        text-transform: none;
                    `}
        >
            about this report <FaQuestionCircle style={{ verticalAlign: "text-top" }} />
        </div>
        <Modal
            isOpen={isOpen}
            onRequestClose={closeModal}
            style={modalStyles}
            contentLabel={`${title} - About this Report`}
        >
            <div
                css={css`
                        display: flex;
                        align-items: center;
                        & > h1 {
                            margin: 0.5rem 0;
                            font-size: 1.5rem;
                            font-weight: 500;
                            color: #000;
                            & span {
                                opacity: 0.65;
                                display: inline-block;
                                font-size: 0.8em;
                                margin-left: 1em;
                                text-transform: uppercase;
                            }
                            & strong {
                                display: inline-block;
                                margin-left: 0.5em;
                            }
                        }
                        margin-bottom: 1rem;
                    `}
            >
                <h1
                    css={css`
                            flex: 1;
                        `}
                >
                    {title} <span>About this Report</span>
                </h1>
                <div
                    onClick={closeModal}
                    css={css`
                            font-size: 1.5rem;
                            font-weight: 500;
                            color: #999;
                            cursor: pointer;
                            &:hover {
                                color: #000;
                            }
                        `}
                >
                    ×
                </div>
            </div>
            <div
                css={css`
                        max-height: 70vh;
                        overflow: auto;
                        padding-right: 0.5rem;
                    `}
            >
                {Component ? <Component /> : null}
            </div>
        </Modal>
    </>;
}